// src/app/config/customer1.config.ts

import {CustomerConfig} from "../CustomerConfig";

// PUM Config
export const customer4Config: CustomerConfig = {
  icons: {
    favIcon: 'ParkingFox-Signet_RGB.png',
    icon: 'ParkingFox-Signet_RGB.png',
  },
  strings: {
    title: 'Parkticket online bezahlen | Parking Fox GmbH',
    footerText: "test",
    email: "hilfe@parkingfox.de",
    number: "02166 275420",
    contactRef: "https://www.parkingfox.de/impressum",
    dataProtectionRef: "https://www.parkingfox.de/datenschutzkamera",
    metaDescription: "Parkticket jetzt online bezahlen mit Parking Fox – einfach, sicher & ohne Registrierung über pay.parkingfox.de. Kennzeichen eingeben, Zahlung abschließen & weiterfahren.",
  }
};
